"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _Nothing = _interopRequireDefault(require("../Nothing"));

var _core = require("@material-ui/core");

var styles = function styles(theme) {
  return {
    message: {
      display: 'flex',
      alignItems: 'center'
    },
    icon: {
      marginRight: theme.spacing(2)
    },
    info: {
      backgroundColor: theme.palette.info.main,
      color: theme.palette.primary.contrastText
    },
    success: {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.primary.contrastText
    },
    error: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var Snackbar = function Snackbar(_ref) {
  var timestamp = _ref.timestamp,
      open = _ref.open,
      type = _ref.type,
      children = _ref.children,
      dataQa = _ref.dataQa,
      autoHideDuration = _ref.autoHideDuration,
      onClose = _ref.onClose,
      onExited = _ref.onExited;
  var classes = useStyles();
  var iconTypes = {
    info: _Info["default"],
    success: _CheckCircle["default"],
    error: _Error["default"]
  };
  var Icon = iconTypes[type] || _Nothing["default"];

  var onCloseInternal = function onCloseInternal(event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    onClose(event);
  };

  return /*#__PURE__*/_react["default"].createElement(_core.Snackbar, {
    key: timestamp,
    "data-qa": dataQa,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    open: open,
    autoHideDuration: autoHideDuration,
    onClose: onCloseInternal,
    onExited: onExited,
    ContentProps: {
      'aria-describedby': 'snackbar-message',
      className: classes[type]
    },
    message: /*#__PURE__*/_react["default"].createElement("span", {
      id: "snackbar-message",
      className: classes.message
    }, /*#__PURE__*/_react["default"].createElement(Icon, {
      className: classes.icon
    }), children),
    action: /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      "aria-label": "Close",
      color: "inherit",
      onClick: onCloseInternal
    }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      fontSize: "small"
    }))
  });
};

Snackbar.propTypes = {
  /** Selector for QA */
  dataQa: _propTypes["default"].string.isRequired,

  /** Duration after which to close the snackbar */
  autoHideDuration: _propTypes["default"].number,

  /**
   * Time the snackbar was opened. Necessary for reopening the
   * snackbar when the content may not have changed.
   *
   * Suggestion: use new Date().getTime()
   */
  timestamp: _propTypes["default"].number,

  /** If `true`, the snackbar is open */
  open: _propTypes["default"].bool.isRequired,

  /** The type of the notification. */
  type: _propTypes["default"].oneOf(['info', 'success', 'error']),

  /** The content of the component. */
  children: _propTypes["default"].node,

  /** Callback fired when the snackbar is closed */
  onClose: _propTypes["default"].func.isRequired,

  /** Callback fired when a snackbar item exits */
  onExited: _propTypes["default"].func.isRequired
};
Snackbar.defaultProps = {
  type: 'info',
  autoHideDuration: 6000
};
var _default = Snackbar;
exports["default"] = _default;